import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var sliderService = {
    sliderTanimlama(oncekiSliderKodu, resim, background, anaBaslik, altBaslik, aciklama, link1,linkButon1,link2,linkButon2,durum, dil) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                oncekiSliderKodu: oncekiSliderKodu,
                resim: resim,
                background: background,
                anaBaslik: anaBaslik,
                altBaslik: altBaslik,
                aciklama: aciklama,
                link1: link1,
                linkButon1: linkButon1,
                link2: link2,
                linkButon2: linkButon2,
                durum: durum,
                dil: dil,
                serviceName : "slider",
                methodName: "sliderTanimlama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    sliderList(dil, durum, baslangic, limit) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                dil: dil,
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName : "slider",
                methodName: "sliderList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    sliderDurumGuncelle(sliderKodu, durum) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                sliderKodu: sliderKodu,
                durum: durum,
                serviceName : "slider",
                methodName: "sliderDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    sliderKisaListe() {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                serviceName : "slider",
                methodName: "sliderKisaList"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    sliderDetay(sliderKodu) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                sliderKodu: sliderKodu,
                serviceName : "slider",
                methodName: "sliderDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    sliderGuncelle(sliderKodu, updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                sliderKodu: sliderKodu,
                updateList: updateList,
                serviceName : "slider",
                methodName: "sliderGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default sliderService

